import { PersonTable } from 'modules/components/layer25';
import { ActivitySectionLayout } from 'modules/components/layer32';
import React from 'react';



export type TeamDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: TeamDetailSectionProps) => {

  return (
    <ActivitySectionLayout.FC>
      <PersonTable.FC />
    </ActivitySectionLayout.FC>
  );
};
